import React, { useRef } from 'react'
import { Route, Redirect, Switch, useRouteMatch, useHistory } from 'react-router-dom'
import { withTranslation } from 'react-i18next'
import IdleTimer from 'react-idle-timer'
import PageNotFound from 'shared/components/PageNotFound.jsx'
import PrivateRoute from './PrivateRoute'
import PrivacyNotice from '../PrivacyNotice/index'
import CaseInformation from '../CaseInformation/index'
import CasePaymentInformation from '../CasePaymentInformation/index'
import CasesList from '../CasesList/index'
import ContactInformation from '../ContactInformation/index'
import ReviewConfirmation from '../ReviewConfirmation/index'
import ReceiveConfirmation from '../ReceiveConfirmation/index'
import Confirmation from '../Confirmation/index'
import Layout from 'containers/Layout/topbar/index.jsx'
import Footer from 'containers/Layout/footer/footer.jsx'

const PayRestitutionRoutes = ({ t, i18n }) => {
  const match = useRouteMatch()
  const history = useHistory()
  const idleMinutes = process.env.REACT_APP_IDLE_TIMEOUNT_MINUTES

  const idleEl = useRef(null)

  const onIdle = () => {
    // history.push(`${match.path}${t('routes.privacy_notice')}`)
    history.push(`${match.path}${t('routes.case_info')}`)
  }

  return (
    <React.Fragment>
      <IdleTimer ref={idleEl} element={document} onIdle={onIdle} debounce={250} timeout={1000 * 60 * parseFloat(idleMinutes)} />
      <Layout />
      <Switch>
        <Route path={`${match.path}${t('routes.not_found')}`} component={PageNotFound} />
        <PrivateRoute path={`${match.path}${t('routes.receive_confirmation')}/:transId/:transOwner`} component={ReceiveConfirmation} />
        <Route path={`${match.path}${t('routes.confirmation')}`} component={Confirmation} />
        <PrivateRoute path={`${match.path}${t('routes.review_confirmation')}`} component={ReviewConfirmation} />
        <PrivateRoute path={`${match.path}${t('routes.contact_info')}`} component={ContactInformation} />
        <PrivateRoute path={`${match.path}${t('routes.listed_cases')}`} component={CasesList} />
        <PrivateRoute path={`${match.path}${t('routes.case_owing_info')}`} component={CasePaymentInformation} />
        <Route path={`${match.path}${t('routes.case_info')}`} component={CaseInformation} />
        {/* <Route path={`${match.path}${t('routes.privacy_notice')}`} component={PrivacyNotice} /> */}
        <Redirect from={`/${i18n.language}/*`} to={`${match.path}${t('routes.not_found')}`} />
        {/* <Redirect exact from={`${match.path}`} to={`${match.path}${t('routes.privacy_notice')}`} /> */}
        <Redirect exact from={`${match.path}`} to={`${match.path}${t('routes.case_info')}`} />
      </Switch>
      <Footer />
    </React.Fragment>
  )
}

export default withTranslation('common')(PayRestitutionRoutes)
